import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import Header from '../../components/Header/Header';
import DesktopFooter from '../../components/shared/DesktopFooter/DesktopFooterLandingPageG';
import Loader from '../../components/shared/Loader/Loader';
import MobileFooter from '../../components/shared/MobileFooter/MobileFooterLandingPage';
import GlobalStyle from '../../global.styles';
import { SubTitle, Title } from './PrivacyPolicy.style';

const BizdocsConst = () => {
	const { t } = useTranslation();
	const breadCrumbLinks = [
		{
			text: t('home_title'),
			href: '/',
			key: '1'
		}
	];
	return (
		<>
			<GlobalStyle />
			<Header bgColor="#6CB93D" />


			<div className="container h-100" style={{ color: "#585858"}}>
				<Title margin="20px 0">Termos e Condições</Title>
				<br />
				<SubTitle margin="20px 0">Bem-vindo ao Arquivo Digital Bizdocs para Sage For Accountants!</SubTitle>
				<p style={{ color: "#585858" }} >
					Estamos gratos por utilizar os nossos produtos e serviços (“Serviços”). Os Serviços são fornecidos pela
					Latourrette Consulting - Consultoria de Inovação em Gestão da Informação, LDA, uma empresa constituída e a operar
					de acordo com as leis de Portugal (NIPC: 509358772), e sediada em Rua do Outeiro, nº2, 1.º andar frente, Porto – Portugal.
				</p>
				<p style={{ color: "#585858" }} >
					Ao utilizar os nossos Serviços, o utilizador está a aceitar os presentes termos de utilização. Leia-os atentamente.
				</p>
				<p style={{ color: "#585858" }} >
					O serviço de Arquivo Digital Bizdocs para Sage For Accountants destina-se exclusivamente ao segmento de PME’s
					(de acordo com a classificação oficial do IAPMEI) e Gabinetes de Contabilidade (CAE 69200 ou Contabilista Certificado em nome individual).
				</p>
				<p style={{ color: "#585858" }} >
					Consideram-se empresas elegíveis para utilização do serviço as que cumpram o requisito de PME, de acordo com o
					<a style={{ color: "#6CB93D" }} href="https://dre.pt/home/-/dre/67356342/details/maximized?p_auth=9EO9pidC"> decreto-lei 98/2015</a>.
					Na eventualidade de não se verificar o requisito mencionado, uma proposta personalizada será elaborada.
					Consideram-se médias entidades aquelas que, de entre as referidas no artigo 3.º, à data do balanço, não ultrapassem dois dos três limites seguintes (salvo situações referidas nos números anteriores):
					<ol className="list-ul" type="a">
						<li style={{ color: "#585858" }} className="pb-4 pl-4">
							Total do balanço: (euros) 20 000 000;
						</li>
						<li style={{ color: "#585858" }} className="pb-4 pl-4">
							Volume de negócios líquido: (euros) 40 000 000;
						</li>
						<li style={{ color: "#585858" }} className="pb-4 pl-4">
							Número médio de empregados durante o período: 250.
						</li>
					</ol>
				</p>
				<p style={{ color: "#585858" }} >
					Os nossos Serviços são muito diversificados, pelo que, por vezes, podem aplicar-se termos de utilização ou requisitos de produto adicionais
					(incluindo requisitos de idade). Os termos de utilização adicionais estarão disponíveis em conjunto com os respetivos Serviços,
					tornando-se parte do contrato entre o utilizador e a Latourrette Consulting, caso aquele utilize os referidos Serviços.
				</p>

				<br />
				<SubTitle margin="20px 0">Utilização dos nossos serviços</SubTitle>
				<p style={{ color: "#585858" }} >
					Deve seguir todas as políticas que lhe são disponibilizadas nos Serviços.
					Não utilize indevidamente os nossos Serviços. Por exemplo, não interfira com os nossos Serviços, nem tente aceder aos mesmos através
					de outros métodos que não a interface e as instruções que fornecemos. Pode utilizar os nossos Serviços apenas nos termos permitidos por lei,
					incluindo leis e regulamentos de controlo de exportações e reexportações aplicáveis. Podemos suspender ou deixar de fornecer os Serviços ao
					utilizador, caso este não respeite os nossos termos ou políticas de utilização ou se estivermos a investigar uma possível conduta imprópria.
				</p>
				<p style={{ color: "#585858" }} >
					A utilização dos nossos Serviços não confere ao utilizador quaisquer direitos de propriedade intelectual sobre os nossos Serviços
					ou o conteúdo acedido. Não pode utilizar conteúdo dos nossos Serviços, salvo mediante autorização do respetivo proprietário ou em
					circunstâncias permitidas por lei. Os presentes termos de utilização não concedem o direito de utilizar nenhuma das marcas ou logótipos
					usados nos nossos Serviços. O utilizador não deverá remover, ocultar ou alterar qualquer aviso legal apresentado nos nossos Serviços ou
					juntamente com os mesmos.
				</p>
				<p style={{ color: "#585858" }} >
					Os nossos Serviços apresentam alguns conteúdos que não pertencem à Latourrette Consulting. Estes conteúdos são da inteira responsabilidade
					da entidade que os disponibiliza. Poderemos avaliar conteúdo para determinar se é ilegal ou se viola as nossas políticas e poderemos remover
					ou recusar apresentar conteúdo que, de uma forma razoável, considerarmos que viola as nossas políticas ou a lei. Não obstante, isso não significa
					necessariamente que avaliamos o conteúdo, pelo que não deve partir do princípio de que o fazemos.
				</p>
				<p style={{ color: "#585858" }} >
					Poderemos enviar-lhe anúncios de serviços, mensagens administrativas e outras informações relacionados com a sua utilização dos Serviços.
					Pode optar por não receber algumas dessas comunicações.
				</p>
				<p style={{ color: "#585858" }} >
					Alguns dos nossos Serviços estão disponíveis em dispositivos móveis. Não utilize estes Serviços de forma a que constituam uma distração
					e o impeçam de obedecer às leis rodoviárias ou de segurança.
				</p>

				<br />
				<SubTitle margin="20px 0">A sua conta Arquivo Digital Bizdocs</SubTitle>
				<p style={{ color: "#585858" }} >
					Para utilizar alguns dos nossos Serviços é necessário ter uma conta Arquivo Digital Bizdocs.
				</p>
				<p style={{ color: "#585858" }} >
					O Arquivo Digital Bizdocs é bastante versátil e foi desenhado para se adaptar às diversas necessidades de um escritório de contabilidade.
					A subscrição do Arquivo Digital Bizdocs é feita mediante código de ativação fornecido pela SAGE ou um parceiro SAGE.
					Para proteger a sua conta, mantenha a sua palavra-passe confidencial. É responsável pela atividade realizada na sua conta ou através da mesma.
					Tente não reutilizar a palavra-passe da sua conta em aplicações de terceiros. Se tiver conhecimento de qualquer utilização não autorizada
					da sua palavra-passe ou da sua conta, contacte-nos imediatamente.
				</p>

				<br />
				<SubTitle margin="20px 0">Definições Gerais</SubTitle>
				<p style={{ color: "#585858" }} >
					O escritório de contabilidade e as PMEs suas clientes são utilizadores finais do Arquivo Digital Bizdocs. Os escritórios de contabilidade
					subscrevem os serviços do Arquivo Digital Bizdocs para o seu escritório e seus clientes.
					O escritório de contabilidade pode criar contas de utilizador para si e para as empresas suas clientes a quem presta serviços de contabilidade.
				</p>

				<br />
				<SubTitle margin="20px 0">Subscrição Base (Arquivo Digital Bizdocs) - Escritório de contabilidade</SubTitle>
				<p style={{ color: "#585858" }} >
					Com o serviço de Arquivo Digital Bizdocs o escritório de contabilidade deixa de estar dependente de um escritório físico.
					Passa assim a ser mais fácil encontrar os documentos e tem a garantia de que os recebeu. Facilite a organização, classificação e
					processo de arquivo, ficando estes disponíveis em tempo real.
					Poder disponibilizar aos seus clientes o acesso, a qualquer momento, à documentação contabilística - à qual, de outra forma,
					não teria acesso durante todo o tempo em que estivesse no gabinete.
				</p>
				<p style={{ color: "#585858" }} >
					A subscrição base do serviço apresenta as seguintes características:
				</p>
				<ul className="list-ul">
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Uma conta do escritório de contabilidade
							<ul className="list-ul">
								<li style={{ color: "#585858" }} className="pb-4 pl-4">
									Utilizadores e Contas:
										<ul className="list-ul">
											<li style={{ color: "#585858" }} className="pb-4 pl-4">
												1 utilizador Contabilista – perfil de administrador
											</li>
											<li style={{ color: "#585858" }} className="pb-4 pl-4">
												1 utilizador Contabilista – perfil de utilizador
											</li>
											<li style={{ color: "#585858" }} className="pb-4 pl-4">
												É possível adicionar mais utilizadores ao escritório de contabilidade mediante subscrição adicional
											</li>
										</ul>
								</li>
								<li style={{ color: "#585858" }} className="pb-4 pl-4">
									Armazenamento:
										<ul className="list-ul">
											<li style={{ color: "#585858" }} className="pb-4 pl-4">
												Inbox de documentos (contabilista) - 1GB, este espaço de armazenamento é aplicável a todos os
												documentos digitalizados pelo contabilista e que aguardam a sua confirmação para envio para contabilização.
												Após a contabilização do documento o espaço deste documento na Inbox será restituído.
											</li>
									<li style={{ color: "#585858" }} className="pb-4 pl-4">
												Arquivo de Gestão Documental - 1GB por empresa, para outros tipos documentos não fiscalmente relevantes do
												escritório de contabilidade e para partilha de documentos com os clientes. É possível adicionar espaço a
												este arquivo mediante subscrições adicionais (20GB ou 40GB).
											</li>
											<li style={{ color: "#585858" }} className="pl-4">
												O carregamento de ficheiros pode ser feito no formato pdf, png, jpg e zip (ficheiros destes formatos). O tamanho máximo de cada ficheiro é de 10Mb.
												É possível aumentar o tamanho máximo e adicionar espaço adicional à Inbox mediante uma subscrição adicional. Contacte-nos para saber mais.
											</li>
										</ul>
								</li>
							</ul>
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Uma conta PME (cliente) do escritório de contabilidade
							<ul className="list-ul">
								<li style={{ color: "#585858" }} className="pb-4 pl-4">
									Utilizadores e Contas:
										<ul className="list-ul">
											<li style={{ color: "#585858" }} className="pb-4 pl-4">
												1 utilizador com perfil de administrador
											</li>
											<li style={{ color: "#585858" }} className="pb-4 pl-4">
												É possível adicionar mais contas PME e utilizadores mediante subscrições adicionais.
											</li>
										</ul>
								</li>
								<li style={{ color: "#585858" }} className="pb-4 pl-4">
									Armazenamento:
										<ul className="list-ul">
											<li style={{ color: "#585858" }} className="pb-4 pl-4">Arquivo ilimitado para documentos fiscalmente relevantes no âmbito das boas práticas da atividade profissional e ao abrigo do DL28/2019, aplicável nas seguintes condições:
											<ul className="list-ul">
												<li style={{ color: "#585858" }} className="pb-4 pl-4">Documentos fiscalmente relevantes com lançamento contabilístico associado e excluindo quaisquer anexos ao documento fiscalmente relevante que está a ser efetivamente contabilizado.</li>
												<li style={{ color: "#585858" }} className="pb-4 pl-4">A todos os documentos do ano fiscal e seguintes, relativos à data de inicio da subscrição do arquivo digital. O arquivo de histórico de documentos, ou seja, anteriores ao ano fiscal relativo ao inicio da subscrição pode ser contratado mediante proposta especifica.</li>
											</ul>
												<p style={{ color: "#585858" }} >
													Tipos de documentos fiscalmente relevantes suportados:
													<ul className="list-ul">
														<li style={{ color: "#585858" }} className="pb-4 pl-4">
															"FT" – Fatura, emitida nos termos do artigo 36.º do Código do IVA
														</li>
														<li style={{ color: "#585858" }} className="pb-4 pl-4">
															"FS" – Fatura simplificada, emitida nos termos do artigo 40.º do Código do IVA
														</li>
														<li style={{ color: "#585858" }} className="pb-4 pl-4">
															"FR" – Fatura-recibo
														</li>
														<li style={{ color: "#585858" }} className="pb-4 pl-4">
															"FI" – Fatura emitida no estrangeiro
														</li>
														<li style={{ color: "#585858" }} className="pb-4 pl-4">
															"ND" – Nota de débito
														</li>
														<li style={{ color: "#585858" }} className="pb-4 pl-4">
															"RC" – Recibo emitido no âmbito do regime de IVA de Caixa (incluindo os relativos a adiantamentos desse regime)
														</li>
														<li style={{ color: "#585858" }} className="pb-4 pl-4">
															"RG" – Outros recibos emitidos
														</li>
														<li style={{ color: "#585858" }} className="pb-4 pl-4">
															"RP" – Prémio ou recibo de prémio
														</li>
														<li style={{ color: "#585858" }} className="pb-4 pl-4">
															"RE" – Estorno ou recibo de estorno
														</li>
														<li style={{ color: "#585858" }} className="pb-4 pl-4">
															 Recibos verdes eletrónicos
														</li>
													</ul>
												</p>
												<p style={{ color: "#585858" }} >
											Consideram-se que outros tipos de documento fiscalmente relevantes, ex: “Documentos bancários” são suportados, porem devem apresentar apenas as páginas relevantes no âmbito das boas práticas.
												</p>
												<p style={{ color: "#585858" }} >
													O tratamento de outros tipos de documentos pode ser contratado mediante proposta específica.
												</p>
												<p style={{ color: "#585858" }} >
													Considera-se que 1 documento digital é constituído por apenas 1 tipo de documento fiscalmente relevante.
												</p>
											</li>
											<li style={{ color: "#585858" }} className="pb-4 pl-4">
										Inbox de documentos (empresa) - 1GB, este espaço de armazenamento é aplicável a todos os documentos
										digitalizados pelo contabilista e que aguardam a sua confirmação para envio para contabilização.
										Após a contabilização do documento o espaço deste documento na Inbox será restituído.
											</li>
											<li style={{ color: "#585858" }} className="pl-4">
												O carregamento de ficheiros pode ser feito no formato pdf, png, jpg e zip (ficheiros destes formatos). O tamanho máximo de cada ficheiro é de 10Mb.
												É possível aumentar o tamanho máximo e adicionar espaço adicional à Inbox mediante uma subscrição adicional. Contacte-nos para saber mais.
											</li>
										</ul>
								</li>
							</ul>
					</li>
				</ul>

				<SubTitle margin="20px 0">Subscrição adicional de Pacote Lançamentos Automáticos (extração de metadados) - obrigatória a prévia subscrição base do Arquivo Digital Bizdocs</SubTitle>
				<p style={{ color: "#585858" }} >
					Existem empresas que pretendem ter a contabilidade organizada ao dia para suportarem decisões do negócio.
					A informação atualizada no momento é um fator chave na gestão das empresas, que têm definidos os seus ciclos de contabilidade no início de cada mês.
					Os lançamentos automáticos vêm colmatar essa necessidade, possibilitando a captura da informação a partir de documentos digitalizados ou PDFs,
					possibilitando assim o lançamento automático e imediato destes documentos – à semelhança dos lançamentos automáticos a partir do SAFT-Vendas ou do e-Fatura.
				</p>
				<ul className="list-ul">
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Considera-se 1 lançamento automático por documento (PDF), sendo este um tipo de documento fiscalmente relevante.
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						A subscrição de cada pacote tem a validade de 1 ano, sendo que, após este período, a subscrição expira e será desativada.
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Considera-se que um documento tem em média 1,5 páginas. E como tal, 1 pacote de 50 documentos terá no máximo 75 páginas.
						Ultrapassadas as 75 páginas, ainda com menos de 50 documentos, terá de ser adquirido um novo pacote.
						Os anexos aos documentos fiscalmente relevantes serão contados como novos documentos e o respetivo número de páginas adicionais.
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Não são extraídas linhas de artigos.
						Extração de linhas poderão ser contratadas mediante proposta específica.
					</li>
				</ul>
				<p style={{ color: "#585858" }} >
					Aplicam-se os seguintes níveis de serviço relativamente ao tempo de processamento, para documentos portugueses e intracomunitários:
				</p>
				<ul className="list-ul">
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Durante os primeiros três meses em média 2 dias úteis
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Após o terceiro mês em média 1 dia útil
					</li>
				</ul>
				<p style={{ color: "#585858" }} >
					Para documentos extracomunitários, podem ser contratados níveis de serviço mediante proposta específica.
				</p>
				<SubTitle margin="20px 0">
					Outras características dos serviços:
				</SubTitle>
				<ul className="list-ul">
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						O Arquivo Digital Bizdocs garante até 80% dos documentos ou metadados reconhecidos desde que os documentos cumpram padrões de qualidade aceitáveis.
						É utilizada a melhor tecnologia disponível para a captura da informação dos documentos, através de um processo de leitura ótica dos caracteres no documento (OCR).
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						O cérebro da nossa solução consiste na aplicação de algoritmos de inteligência artificial capazes de capturar a informação determinante dos documentos
						contabilísticos. Trata-se de um processo de aprendizagem automática (Machine Learning), o que poderá levar até 3 meses para que o sistema consiga
						atingir até 80% dos documentos/metadados reconhecidos para cada cliente(PME) novo ativado na solução.<br />
						<span style={{ color: "#585858"}}>Considera-se que durante os primeiros três meses o sistema garante no mínimo 50% de sucesso e após o terceiro mês no mínimo 80% de sucesso. Aplicável para o mínimo de 1000 documentos processados pelo sistema.</span>
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Este elemento é determinante para possibilitar o lançamento e a associação automática do documento. Por diversos motivos, tais como a falta de qualidade
						do documento, poderá não ser possível aos nossos algoritmos realizar o reconhecimento na íntegra do documento, o que impedirá a extração parcial ou total
						dos metadados relevantes. Nestes casos, o utilizador terá de realizar uma intervenção manual para concluir o processo. Níveis superiores de OCR e de extração
						de metadados podem ser contratados mediante proposta específica.
					</li>
				</ul>

				<SubTitle margin="20px 0">Política de Subscrição</SubTitle>
				<p style={{ color: "#585858" }} >
					Subscreva e comece a usar o Arquivo Digital Bizdocs ainda hoje.
					Ao subscrever o Arquivo Digital Bizdocs concorda em iniciar a sua subscrição imediatamente e reconhece que prescinde do direito de livre resolução e que
					não pode receber um reembolso após aceder à solução. A primeira mensalidade deverá ser paga no mês da subscrição.
				</p>

				<br />
				<SubTitle margin="20px 0">Política de Cancelamento</SubTitle>
				<p style={{ color: "#585858" }} >
					O utilizador pode deixar de utilizar os Serviços e cancelar a sua subscrição a qualquer momento, embora tenhamos pena de o ver partir.
					O cancelamento entrará em vigor no final do período de faturação.
					Não há lugar a reembolsos nem créditos de meses ou anos parciais.
					Todos os pedidos de cancelamento de subscrições devem ser realizados junto da equipa de suporte, através do email <a href="mailto:support@bizdocs.mobi" style={{ color: "#6CB93D" }}>support@bizdocs.mobi. </a>
				</p>
				<p style={{ color: "#585858" }} >
					O que acontece depois de eu cancelar a minha subscrição?
				</p>
				<p style={{ color: "#585858" }} >
					Após a sua subscrição ser cancelada os seus serviços serão desativados.
					A Latourrette Consulting espera até 90 dias antes de apagar permanentemente os seus dados, caso necessite de aceder aos mesmos para fazer
					uma cópia de segurança ou mude de ideias. Neste período, o seu acesso estará limitado para consulta e download de documentos,
					não sendo possível carregar novos documentos. Não lhe cobramos pela retenção dos dados dentro deste período.
					A Latourrette Consulting tem serviços para a exportação em massa dos seus documentos mediante proposta comercial especifica,
					contacte-nos através do email <a href="mailto:support@bizdocs.mobi" style={{ color: "#6CB93D" }}>support@bizdocs.mobi. </a>
				</p>

				<br />
				<SubTitle margin="20px 0">Política de Bloqueio</SubTitle>
				<p style={{ color: "#585858" }} >
					A Latourrette Consulting remete-se ao direito de bloquear o acesso ao Arquivo Digital a todos os utilizadores (contabilista e empresas), nos seguintes casos:
				</p>
				<ul className="list-ul">
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Para garantir a segurança do serviço ou do canal de acesso;
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Quando o serviço for utilizado de forma fraudulenta, abusiva ou contrária ao propósito a que se destina especificamente – arquivo legal de documentos fiscalmente relevantes;
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Quando for necessário realizar operações de manutenção ou reparação do serviço
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Quando se verifique um incumprimento do pagamento por parte do utilizador final (contabilista).
					</li>
				</ul>
				<p style={{ color: "#585858" }} >
					Em caso de bloqueio de conta, por favor, contacte a nossa equipa de Suporte para o podermos ajudar, através do email <a href="mailto:support@bizdocs.mobi" style={{ color: "#6CB93D" }}>support@bizdocs.mobi. </a>
				</p>

				<br />
				<SubTitle margin="20px 0">Privacidade e Proteção de Direitos de Autor / Copyright</SubTitle>
				<p style={{ color: "#585858" }} >
					As Políticas de Privacidade do Arquivo Digital Bizdocs explicam como tratamos os seus dados pessoais e protegemos a sua privacidade quando utiliza os nossos Serviços.
					De acordo com o processo definido no Digital Millennium Copyright Act dos EUA, respondemos a avisos de alegadas violações de direitos de autor / copyright e rescindimos as contas dos infratores reincidentes.
					Providenciamos informações para ajudar os detentores de direitos de autor / copyright a gerir a respetiva propriedade intelectual on-line. Se acha que alguém está a violar os seus direitos de autor / copyright e pretender notificar-nos, pode fazê-lo através do email <a href="mailto:support@bizdocs.mobi" style={{ color: "#6CB93D" }}>support@bizdocs.mobi. </a>
				</p>

				<br />
				<SubTitle margin="20px 0">O seu Conteúdo nos nossos Serviços</SubTitle>
				<p style={{ color: "#585858" }} >
					Alguns dos nossos serviços permitem ao utilizador carregar, submeter, armazenar, enviar ou receber conteúdo. O utilizador mantém a propriedade de todos os
					direitos de propriedade intelectual que detenha sobre o referido conteúdo. Em suma, o que lhe pertence continuará a pertencer-lhe.
					Quando carrega, submete, armazena, envia ou recebe conteúdo para ou através dos nossos Serviços, está a conceder à Latourrette Consulting
					(e àqueles com quem trabalhamos) uma licença internacional para utilizar, alojar, armazenar, reproduzir, modificar, criar trabalhos derivados
					(como os decorrentes de traduções, adaptações ou outras alterações que efetuarmos para que o conteúdo funcione melhor com os nossos Serviços),
					comunicar, publicar, executar e apresentar publicamente, bem como distribuir o referido conteúdo. Os direitos que o utilizador concede ao abrigo desta licença
					serão utilizados apenas para operar, promover e aperfeiçoar os nossos Serviços, assim como desenvolver novos serviços. Esta licença permanece em vigor mesmo
					que o utilizador deixe de utilizar os nossos Serviços.
					<br/>
					Alguns Serviços podem disponibilizar ao utilizador formas de acesso e remoção de conteúdo que tenha
					sido fornecido a esse Serviço. Além disso, em alguns dos nossos Serviços, existem termos e definições que restringem o âmbito da utilização que fazemos do
					conteúdo enviado para esses Serviços. Certifique-se de que possui os direitos necessários relativos a qualquer conteúdo que envia para os nossos Serviços.
					Os nossos sistemas automatizados analisam o seu conteúdo (incluindo emails) para lhe fornecer funcionalidades do produto relevantes,
					como resultados de pesquisa personalizados, deteção de spam e software maligno. Esta análise ocorre quando o conteúdo é enviado, recebido e quando é armazenado.
				</p>
				<p style={{ color: "#585858" }} >
					Se tiver uma Conta Bizdocs, poderemos apresentar o seu nome e a sua fotografia do Perfil, assim como as ações realizadas na Bizdocs ou em aplicações
					de terceiros associados à sua Conta Bizdocs nos nossos Serviços. Respeitaremos as suas escolhas para limitar as definições de partilha ou de visibilidade da sua Conta Bizdocs.
					Pode encontrar mais informações acerca da forma como a Bizdocs utiliza e armazena conteúdos na política de privacidade ou nos termos de utilização adicionais
					para determinados Serviços. Se enviar comentários ou sugestões acerca dos nossos Serviços, poderemos utilizá-los sem assumir qualquer obrigação perante si.
				</p>

				<br />
				<SubTitle margin="20px 0">Acerca do software nos nossos serviços</SubTitle>
				<p style={{ color: "#585858" }} >
					Quando um Serviço requer ou inclui software transferível, este software pode ser atualizado automaticamente no aparelho do utilizador,
					assim que a nova versão ou funcionalidade esteja disponível. Alguns Serviços poderão permitir que o utilizador ajuste as definições da atualização automática.
				</p>
				<p style={{ color: "#585858" }} >
					O Arquivo Digital Bizdocs concede ao utilizador uma licença internacional, intransmissível, não exclusiva e isenta de royalties para utilizar o software
					que lhe é fornecido pela Latourrette Consutling como parte dos Serviços. Esta licença tem como único objetivo permitir a utilização e usufruto dos benefícios
					dos Serviços tal como são fornecidos pela Latourrette Consulting, da forma que é permitido pelos presentes termos de utilização. O utilizador não pode copiar,
					modificar, distribuir, vender ou alugar qualquer parte dos nossos Serviços ou do software neles incluído, nem utilizar engenharia reversa ou tentar extrair o
					código fonte do software, salvo se estas restrições forem proibidas por lei ou se o utilizador tiver o nosso consentimento por escrito.
				</p>
				<p style={{ color: "#585858" }} >
					O software de código aberto é importante para nós. Algum software utilizado nos nossos Serviços poderá ser disponibilizado ao abrigo de uma licença de código aberto.
					Poderão existir disposições na licença de código aberto que substituem expressamente alguns dos presentes termos.
				</p>
				<p style={{ color: "#585858" }} >
					Relativamente às aplicações e navegadores Mobile, o Arquivo Digital Bizdocs garante o seu funcionamento nas versões suportadas pelos fornecedores de software (nomeadamente, Apple e Google).
				</p>
				<ul className="list-ul">
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Navegadores: Chrome em Android e Safari em IOS, últimas versões e duas anteriores.
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Apps Mobile: Sistemas operativos suportados:
						<br/>
						Versões de sistema operativo para telefones Apple: iOS NATIVO. Não suportamos telefone com jailbreak, customizações de interface ou launchers diferentes.
						<br/>
						Versões telefones com Android: Android Stock (NATIVO). Estão excluídas interfaces ou launchers personalizados como o MIU da Xiaomi ou personalizações de outros fabricantes, Samsung, Huawei, etc...
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Versões dos sistemas operativos suportados: Última versão e duas anteriores.
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						Disponibilização do suporte para novas releases de Sistemas operativos: Compromisso de adaptação do nosso SW a novas versões suportadas no período de 90 dias.
					</li>
					<li style={{ color: "#585858" }} className="pb-4 pl-4">
						O Arquivo Digital Bizdocs pode ser executado em versões mais antigas do software, mas não é testado ativamente e não são corrigidos bugs que possam surgir nessas versões.
					</li>
				</ul>

				<SubTitle margin="20px 0">Garantias e Exclusão de Responsabilidade</SubTitle>
				<p style={{ color: "#585858" }} >
					Fornecemos os nossos Serviços com um nível comercialmente razoável de competência e cuidado e esperamos que o utilizador se sinta satisfeito ao utilizá-los.
					No entanto, existem determinadas coisas que não prometemos em relação aos nossos Serviços.
					Salvo se expressamente previsto nos presentes termos de utilização ou nos termos de utilização adicionais, nem a Latourrette Consulting nem os seus
					fornecedores ou distribuidores fazem qualquer promessa específica acerca dos Serviços. Por exemplo, não nos comprometemos quanto aos conteúdos dos Serviços,
					à função específica dos Serviços, à fiabilidade, disponibilidade ou capacidade dos mesmos de satisfazerem as necessidades do utilizador.
					Fornecemos os Serviços «tal como estão».
				</p>
				<p style={{ color: "#585858" }} >
					Algumas jurisdições obrigam a fornecer determinadas garantias, como a garantia implícita de comercialização, adequação a um fim específico e não infração.
					Na medida em que tal seja permitido por lei, excluímos todas as garantias.
				</p>
				<p style={{ color: "#585858" }} >
					As operações de digitalização e arquivo eletrónico devem ser executadas pelo Cliente com o rigor técnico necessário à obtenção e reprodução de imagens perfeitas,
					legíveis e inteligíveis dos documentos originais, sem perda de resolução e informação, de forma a garantir a sua consulta e reprodução em papel ou outro suporte
					eletrónico. A Latourrette Consulting não se responsabiliza pela qualidade original do documento submetido pelo Cliente.
				</p>

				<br />
				<SubTitle margin="20px 0">Responsabilidade pelos nossos serviços</SubTitle>
				<p style={{ color: "#585858" }} >
					Nos casos em que tal seja permitido por lei, a Latourrette Consulting e os fornecedores e distribuidores da Latourrette Consulting não se responsabilizam pela perda de
					lucros, receitas ou dados, perdas financeiras ou danos indiretos, especiais, derivados, exemplares ou punitivos.
					Na medida em que tal seja permitido por lei, a responsabilidade total da Latourrette Consulting e dos seus fornecedores e distribuidores por quaisquer queixas ao abrigo dos presentes termos de utilização, incluindo quaisquer garantias implícitas, está limitada ao valor que o utilizador pagou para utilizar os Serviços nos últimos 30 dias.
				</p>
				<p style={{ color: "#585858" }} >
					Em todos os casos, a Latourrette Consulting e os seus fornecedores e distribuidores não serão responsáveis por qualquer perda ou dano que não seja razoavelmente previsível.
					Reconhecemos que, em alguns países, o utilizador poderá ter direitos legais na qualidade de consumidor. Se estiver a utilizar os Serviços para fins pessoais, nenhuma das disposições contidas nos presentes termos de utilização ou nos termos de utilização adicionais limita qualquer direito legal como consumidor que não possa ser renunciado contratualmente.
				</p>
				<p style={{ color: "#585858" }} >
					Estamos constantemente a alterar e a melhorar os nossos Serviços. Podemos adicionar ou remover funcionalidades ou características, bem como suspender ou parar totalmente um Serviço.
					A Latourrette Consulting pode ainda deixar de fornecer os Serviços ao utilizador ou adicionar ou criar novos limites aos Serviços em qualquer momento.
				</p>

				<br />
				<SubTitle margin="20px 0">Utilização dos nossos Serviços por empresas</SubTitle>
				<p style={{ color: "#585858" }} >
					Se os nossos Serviços estiverem a ser usados por ou em nome de uma empresa, esta terá de aceitar os presentes termos de utilização.
					Compromete-se a isentar e a indemnizar a Latourrette Consulting e as suas filiais, representantes, agentes e funcionários de quaisquer queixas,
					processos ou ações resultantes de ou relacionados com a utilização dos Serviços ou a violação dos presentes termos de utilização,
					incluindo quaisquer responsabilidades ou despesas resultantes de queixas, perdas, danos, processos, ações judiciais, custas e honorários de advogados.
				</p>

				<br />
				<SubTitle margin="20px 0">Acerca dos presentes Termos de Utilização</SubTitle>
				<p style={{ color: "#585858" }} >
					Poderemos modificar estes termos de utilização ou quaisquer termos de utilização adicionais que se apliquem a um Serviço para, por exemplo, refletir alterações
					à lei ou aos nossos Serviços. O utilizador deverá consultar os termos de utilização regularmente. Os avisos de modificação dos presentes termos de utilização
					serão publicados nesta página. Os avisos relativos à modificação dos termos de utilização adicionais serão publicados nos respetivos Serviços.
					As alterações não serão de aplicação retroativa e não entrarão em vigor num período inferior a catorze dias após a sua publicação. Contudo, as alterações
					relativas a novas funcionalidades de um Serviço ou as alterações efetuadas por motivos legais entrarão imediatamente em vigor. Caso o utilizador não aceite
					os termos de utilização modificados de um Serviço, deverá deixar de o utilizar.
				</p>
				<p style={{ color: "#585858" }} >
					Em caso de conflito entre os presentes termos de utilização e os termos de utilização adicionais, estes últimos prevalecem sobre os primeiros.
					Os presentes termos de utilização controlam o relacionamento entre a Latourrette Consulting e o utilizador, não criando quaisquer direitos a terceiros.
				</p>
				<p style={{ color: "#585858" }} >
					Se o utilizador não respeitar os presentes termos de utilização e a Latourrette Consulting não tomar medidas de imediato, tal não implica qualquer desistência
					por parte da Latourrette Consulting de quaisquer direitos que lhe assistam (como, por exemplo, o de tomar medidas no futuro).
				</p>
				<p style={{ color: "#585858" }} >
					Caso se venha a concluir que um determinado termo de utilização não é exequível, tal não afetará os restantes termos.
				</p>

				<br />
				<SubTitle margin="20px 0">Lei e jurisdição aplicáveis</SubTitle>
				<p style={{ color: "#585858" }} >
					Para consumidores a viver no Espaço Económico Europeu ou na Suíça: em caso de litígio decorrente de ou relacionado com os presentes termos,
					aplica-se a lei e a jurisdição do respetivo país de residência. É possível apresentar litígios para resolução online na plataforma de
					Resolução de Litígios em Linha da Comissão Europeia, mas a Latourrette Consulting não se compromete nem está obrigada a resolver litígios
					perante uma entidade de resolução alternativa de litígios.
				</p>
				<p style={{ color: "#585858" }} >
					Para utilizadores comerciais no Espaço Económico Europeu ou na Suíça: os presentes termos são regidos pela lei portuguesa e o utilizador e a
					Latourrette Consulting submetem-se à jurisdição exclusiva dos tribunais portugueses relativamente a qualquer litígio decorrente de ou relacionado
					com os presentes termos. Não obstante, a Latourrette Consulting poderá ainda apresentar medidas cautelares (ou de tipo equivalente de reparação
					judicial urgente) em qualquer jurisdição.
				</p>
				<p style={{ color: "#585858" }} >
					Para obter informações sobre como contactar a Latourrette Consulting, visite: <a style={{ color: "#6CB93D" }} href="https://www.latourrette-consulting.com"> www.latourrette-consulting.com </a>
				</p>
			</div>
			<DesktopFooter />
			<MobileFooter bgColor="#6CB93D"/>
		</>
	);
};

export default function Bizdocs() {
	return (
		<Suspense fallback={<Loader />}>
			<BizdocsConst />
		</Suspense>
	);
}
